var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 299.256 69.038",
    style: {
      enableBackground: "new 0 0 299.256 69.038"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MyNetDiary-Logo-201905-Dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Light"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Title"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56A821"
    },
    d: "M77.106,58.6c0,0,200.17,0,190.48,1.28c-0.79,0.1-149.12,0.77-185.67,3.84 C79.706,63.9,77.106,58.6,77.106,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56A821"
    },
    d: "M104.936,55.53h3.91l-1.93-31h-5.11l-5.53,15c-1.38,3.91-2.48,7.32-3.27,10.45h-0.13 c-0.79-3.22-1.84-6.63-3.13-10.45l-5.3-15h-5.11l-2.16,31h3.82l0.83-13.3c0.27-4.65,0.5-9.86,0.6-13.72h0.09 c0.87,3.68,2.12,7.68,3.59,12.06l5,14.78h3l5.47-15.06c1.57-4.28,2.86-8.15,3.92-11.78h0.14c-0.05,3.86,0.23,9.07,0.46,13.39 L104.936,55.53z M110.836,33.25l8.27,20.53c0.143,0.338,0.234,0.695,0.27,1.06c-0.047,0.35-0.155,0.688-0.32,1 c-0.77,1.748-1.938,3.292-3.41,4.51c-1.041,0.887-2.243,1.566-3.54,2l1,3.41c1.866-0.429,3.589-1.336,5-2.63 c2.76-2.39,4.74-6.31,7.64-14l6.08-15.88h-4.32l-4.4,13.07c-0.55,1.61-1,3.32-1.43,4.65h-0.09c-0.37-1.33-0.92-3.08-1.43-4.55 l-4.88-13.17H110.836z M138.576,55.53V42.27c0-5.15-0.09-8.88-0.32-12.8h0.14c1.724,3.566,3.661,7.026,5.8,10.36l9.85,15.74h4.06 v-31h-3.77v13c0,4.84,0.09,8.61,0.46,12.76h-0.09c-1.647-3.493-3.518-6.877-5.6-10.13l-10-15.7h-4.3v31L138.576,55.53z  M181.776,45.13c0.088-0.626,0.134-1.258,0.14-1.89c0-4.1-1.93-10.5-9.21-10.5c-6.49,0-10.45,5.3-10.45,12s4.1,11.23,11,11.23 c2.539,0.064,5.064-0.407,7.41-1.38l-0.69-2.9c-1.95,0.822-4.055,1.214-6.17,1.15c-4,0-7.55-2.26-7.64-7.73L181.776,45.13z  M166.176,42.23c0.32-2.81,2.11-6.59,6.21-6.59c4.56,0,5.66,4,5.62,6.59H166.176z M187.176,27.91v5.34h-3.45v3.08h3.45v12.16 c0,2.62,0.41,4.6,1.56,5.8c1.14,1.177,2.734,1.8,4.37,1.71c1.22,0.037,2.437-0.149,3.59-0.55l-0.18-3 c-0.767,0.197-1.558,0.291-2.35,0.28c-2.26,0-3-1.57-3-4.33v-12h5.8v-3.15h-5.8v-6.4L187.176,27.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D7E06"
    },
    d: "M200.026,55.44c2.539,0.294,5.094,0.431,7.65,0.41c6,0,11-1.42,14-4.23 c2.94-2.67,4.83-6.82,4.83-12.34c0-5.3-1.84-9-4.83-11.42s-6.86-3.59-12.66-3.59c-3.012-0.021-6.021,0.193-9,0.64L200.026,55.44z  M205.696,29c1.272-0.242,2.566-0.35,3.86-0.32c7.09,0,11.05,3.91,11,10.77c0,7.88-4.38,11.93-11.74,11.88 c-1.045,0.032-2.092-0.015-3.13-0.14L205.696,29z M235.786,55.52V33.11h-5.68v22.42L235.786,55.52z M232.936,23.75 c-1.654-0.1-3.076,1.159-3.176,2.813c-0.006,0.092-0.007,0.185-0.004,0.277c0.004,1.756,1.431,3.177,3.187,3.173 c1.751-0.004,3.169-1.422,3.173-3.173c0.047-1.656-1.257-3.037-2.913-3.084c-0.089-0.003-0.178-0.001-0.267,0.004V23.75z  M258.336,55.52c-0.241-1.786-0.348-3.588-0.32-5.39V42c0-4.88-2.08-9.44-9.26-9.44c-2.828-0.053-5.621,0.637-8.1,2l1.1,3.69 c1.817-1.077,3.888-1.65,6-1.66c3.95,0,4.55,2.44,4.55,3.91v0.37c-8.28,0-13.3,2.81-13.3,8.47 c-0.014,3.673,2.952,6.661,6.625,6.675c0.159,0.001,0.317-0.004,0.475-0.015c2.553,0.069,4.997-1.036,6.63-3h0.14l0.37,2.49 L258.336,55.52z M252.486,47.65c0.006,0.42-0.055,0.839-0.18,1.24c-0.645,1.884-2.429,3.139-4.42,3.11 c-1.652,0.132-3.098-1.099-3.23-2.751c-0.013-0.159-0.013-0.32,0-0.479c0-3.4,3.83-4.28,7.83-4.19V47.65z M262.896,55.52h5.66 V43.93c0.006-0.588,0.07-1.174,0.19-1.75c0.363-2.5,2.534-4.337,5.06-4.28c0.558,0.003,1.114,0.063,1.66,0.18v-5.34 c-0.447-0.097-0.903-0.144-1.36-0.14c-2.854,0.124-5.314,2.049-6.12,4.79h-0.19l-0.18-4.28h-4.91c0.14,2,0.19,4.19,0.19,7.23 L262.896,55.52z M276.836,33.1l8.2,20.58c0.192,0.336,0.302,0.713,0.32,1.1c-0.044,0.358-0.17,0.7-0.37,1 c-0.725,1.412-1.782,2.627-3.08,3.54c-0.996,0.73-2.123,1.263-3.32,1.57l1.29,4.79c2.221-0.365,4.286-1.373,5.94-2.9 c2.67-2.31,4.74-6,7.83-14.42l5.61-15.28h-6.07l-3.5,12c-0.42,1.47-0.83,3.13-1.2,4.42h-0.14c-0.32-1.29-0.78-3-1.24-4.37 l-4.05-12L276.836,33.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.2017,
    y1: 12.9617,
    x2: 29.2017,
    y2: 67.0417,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#81C218"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A8DE0A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M41.956,33.78c-12.815,5.916-26.586,9.489-40.66,10.55h-0.74 c-0.11-0.85-0.21-1.73-0.25-2.63c0,0-2.22-22.15,13.33-25.83c0,0,4.66-1.7,10.21,1.62c1.571,0.761,3.263,1.241,5,1.42 c2.003,0.223,4.029-0.091,5.87-0.91h-0.08c0.66-0.26,1.08-0.46,1.08-0.46c5.57-3.32,10.21-1.6,10.21-1.6 c4.799,1.148,8.765,4.512,10.68,9.06l-0.68,0.58C51.573,28.799,46.89,31.548,41.956,33.78z M42.956,55.91 c5.362-1.989,10.479-4.586,15.25-7.74c-2.251,8.078-7.492,14.997-14.66,19.35c-4.34,2.8-9.86,0.87-9.86,0.87 c-1.318-0.352-2.653-0.636-4-0.85c-1.347,0.212-2.682,0.492-4,0.84c0,0-5.54,1.92-9.86-0.89c-2.192-1.316-4.208-2.906-6-4.73 C21.155,62.185,32.328,59.874,42.956,55.91z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 38.6385,
    x2: 61.1765,
    y2: 38.6385,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EAEAE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAEAE5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M60.746,44.66c-14.47,10.84-34,15.5-51.71,16.71c-0.308,0.025-0.607-0.111-0.79-0.36 c-1.27-1.68-6.14-8.36-8.14-13.72c-0.28-0.74,0-1.26,0.75-1.93c-0.22,0.32-0.35,0.92,0.2,0.86c17.68-1.94,40.23-7.32,56.17-19.38 c0.384-0.25,0.494-0.764,0.244-1.148c-0.106-0.164-0.267-0.285-0.454-0.342c0,0,1.58,0,2.06,0.86s2.03,11.62,2.1,17.59 C61.177,44.139,61.018,44.458,60.746,44.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83898C"
    },
    d: "M8.316,49.31l-1,0.2l-1.21,1.07l0.5,1l0.79-0.66l1.1,4.49l1.24-0.25L8.316,49.31z M23.576,51.31 l-2,0.56c0.8-1.35,1.39-2.48,1.09-3.6c-0.201-0.876-1.014-1.472-1.91-1.4c-0.169,0.013-0.336,0.04-0.5,0.08 c-0.638,0.149-1.202,0.522-1.59,1.05l-0.11,0.16l0.72,0.88l0.2-0.29c0.213-0.31,0.522-0.542,0.88-0.66 c0.381-0.148,0.81,0.041,0.958,0.422c0.02,0.051,0.034,0.104,0.042,0.158c0.18,0.7-0.21,1.51-1.23,3.18l-0.48,0.81l0.22,0.74l4-1 L23.576,51.31z M36.166,47.25c-0.18-0.599-0.684-1.044-1.3-1.15c0.531-0.679,0.411-1.659-0.268-2.19 c-0.288-0.225-0.646-0.342-1.012-0.33c-0.252,0-0.503,0.044-0.74,0.13c-0.56,0.185-1.051,0.533-1.41,1l-0.11,0.16l0.69,0.9 l0.21-0.28c0.208-0.279,0.493-0.491,0.82-0.61c0.11-0.037,0.224-0.057,0.34-0.06c0.249-0.008,0.469,0.159,0.53,0.4 c0.06,0.2,0.011,0.416-0.13,0.57c-0.162,0.179-0.369,0.311-0.6,0.38l-0.66,0.21l0.34,1.05l0.65-0.21 c0.189-0.072,0.388-0.112,0.59-0.12c0.377-0.038,0.73,0.19,0.85,0.55c0.078,0.192,0.078,0.408,0,0.6 c-0.149,0.246-0.39,0.422-0.67,0.49c-0.21,0.066-0.43,0.099-0.65,0.1c-0.168,0-0.336-0.02-0.5-0.06l-0.32-0.08v1.16l0.2,0.06 c0.206,0.052,0.418,0.075,0.63,0.07c0.34-0.002,0.677-0.056,1-0.16c0.599-0.165,1.116-0.546,1.45-1.07 c0.237-0.467,0.262-1.013,0.07-1.5V47.25z M48.106,42.84l-0.41-1.06l-0.73,0.29l-1.26-3.26l-1.15,0.44l-1.09,4.47l0.3,0.79 l2.44-0.94l0.5,1.43l1.16-0.45l-0.55-1.43L48.106,42.84z M44.796,42.91l0.46-1.78l0.54,1.39L44.796,42.91z M58.366,37.32 c-0.273-0.631-0.874-1.059-1.56-1.11c-0.47-0.04-0.941,0.054-1.36,0.27l-0.13,0.06l-0.26-0.85l2-0.94l-0.5-1.06l-2.88,1.37l1,3.14 l0.33-0.2c0.195-0.13,0.399-0.247,0.61-0.35c0.253-0.134,0.534-0.209,0.82-0.22c0.356-0.018,0.685,0.19,0.82,0.52 c0.216,0.508-0.021,1.095-0.529,1.311c-0.007,0.003-0.014,0.006-0.021,0.009c-0.291,0.138-0.608,0.213-0.93,0.22h-0.15h-0.33 l0.14,1.14h0.2h0.26c0.42-0.027,0.831-0.135,1.21-0.32c0.576-0.257,1.031-0.726,1.27-1.31c0.215-0.544,0.193-1.153-0.06-1.68 L58.366,37.32z M10.166,56.94l-1.22,0.14l1.26,4.21l1.24-0.11L10.166,56.94z M22.906,54.8l-1.23,0.2l1.25,4.71l1.18-0.21 L22.906,54.8z M35.906,51.56l-1.17,0.37l1.45,4.68l1.17-0.36L35.906,51.56z M48.176,47.11l-1.14,0.52l1.65,4.22l1.1-0.53 L48.176,47.11z M58.406,41.92l-1.13,0.68l1.21,3.66c0.35-0.23,0.7-0.47,1-0.72L58.406,41.92z M17.256,58.43l-1.23,0.16l0.59,2 l1.23-0.15L17.256,58.43z M43.106,51.77l-1.14,0.45l0.83,2.14l1.14-0.45L43.106,51.77z M30.476,55.63l-1.19,0.29l0.68,2.35 l1.19-0.27L30.476,55.63z M54.476,46.33c-0.35,0.21-0.75,0.36-1.1,0.57l0.73,2.1c0.367-0.2,0.727-0.41,1.08-0.63L54.476,46.33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.4873,
    y1: 64.1029,
    x2: 43.1573,
    y2: 81.9429,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DB922"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#72BC2F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M32.046,17c0,0-2.21-13,11.44-17C43.486,0,45.756,12,32.046,17z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.8852,
    y1: 64.9773,
    x2: 25.5552,
    y2: 75.5473,
    gradientTransform: "matrix(1 0 0 -1 0 82)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9632B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AF7433"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M28.396,17.11c0,0-2.13-6.06-6.16-7.72l4.47-3.28c2.663,3.139,3.94,7.223,3.54,11.32 C29.612,17.502,28.97,17.391,28.396,17.11z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.91b47cff912568ac9859813890072094.svg";
export { ForwardRef as ReactComponent };